export const toCamelCase = (pascalCaseObject: Record<string, any>) => {
  const newObject: any = {}
  let newKey
  let value

  if (pascalCaseObject instanceof Array) {
    return pascalCaseObject.map((value) => {
      let temporaryValue = value
      if (typeof value === 'object') {
        temporaryValue = toCamelCase(value)
      }
      return temporaryValue
    })
  }

  Object.keys(pascalCaseObject).forEach((key) => {
    newKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString()
    value = pascalCaseObject[key]
    if (value instanceof Array || (value !== null && value.constructor === Object)) {
      value = toCamelCase(value)
    }
    newObject[newKey] = value
  })

  return newObject
}

export const isValidResponse = (status?: number) => {
  if (status && (status / 100 === 2 || status / 100 === 3)) {
    // checks if 2** or 3** response type
    return true
  }
  return false
}

export const getCollapsedString = (str: string, stringLength?: number) => {
  const masStringLen = stringLength || 28
  if (str !== null && str.length > masStringLen) {
    return `${str.substring(0, masStringLen)}...`
  }
  return str
}

export const formatPhoneNumber = (phoneNumber: string) => phoneNumber // todo: format number

export const pluralize = (count: number, item: string) => {
  const lowerCaseItem = item.toLowerCase().trim()

  if (count === 1) {
    if (lowerCaseItem.endsWith('s')) return `${count} ${lowerCaseItem.slice(0, -1)}`
    return `${count} ${lowerCaseItem}`
  }
  if (lowerCaseItem.endsWith('s')) return `${count} ${lowerCaseItem}`
  return `${count} ${lowerCaseItem}s`
}

export const pluralizeWithoutCount = (count: number, item: string) => {
  const lowerCaseItem = item.toLowerCase().trim()

  if (count === 1) {
    if (lowerCaseItem.endsWith('s')) return `${lowerCaseItem.slice(0, -1)}`
    return `${lowerCaseItem}`
  }

  if (lowerCaseItem.endsWith('s')) return `${lowerCaseItem}`
  return `${lowerCaseItem}s`
}

export const apostrophy = (text: string) => {
  if (text.endsWith('s')) return `${text}'`
  return `${text}'s`
}

export const getUpdatedListCount = (total: number, ignored: number) => {
  if (ignored > 0) {
    return total - ignored
  }

  return total
}

export const roundToClosestN = (value: number, maxNumberOfDigitsAfterDecimal = 2) => {
  if (!value) return value
  const numberOfDigitsAfterDecimal = value.toString().split('.')[1]?.length
  if (numberOfDigitsAfterDecimal && numberOfDigitsAfterDecimal > maxNumberOfDigitsAfterDecimal) {
    return +value.toFixed(maxNumberOfDigitsAfterDecimal)
  }
  return +value
}

export const isValidUrl = (url?: string) => {
  if (!url) return false
  return /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s?]+)?(?:\?[^\s]*)?$/.test(
    url
  )
}
